module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.0fc25386.ttf";